import { gql } from 'apollo-angular';

// Query to get conversion factor between two units
export const GET_CONVERSION_FACTOR = gql`
  query GetConversionFactor($fromUnit: ID!, $toUnit: ID!, $company: String!) {
    getConversionFactor(
      from_unit: $fromUnit
      to_unit: $toUnit
      company: $company
    )
  }
`;

// Query to convert quantity between units
export const CONVERT_QUANTITY = gql`
  query ConvertQuantity($fromUnit: ID!, $toUnit: ID!, $quantity: Float!) {
    convertQuantity(
      from_unit: $fromUnit
      to_unit: $toUnit
      quantity: $quantity
    ) {
      from_unit
      to_unit
      original_quantity
      converted_quantity
      conversion_factor
      fromUnit {
        id_unit
        description
        dian_code
        id_second
      }
      toUnit {
        id_unit
        description
        dian_code
        id_second
      }
    }
  }
`;

// Query to get a specific conversion
export const GET_UNIT_CONVERSION = gql`
  query GetUnitConversion($idConversion: ID!) {
    getUnitConversion(id_conversion: $idConversion) {
      id_conversion
      from_unit
      to_unit
      conversion_factor
      is_bidirectional
      description
      is_active
      fromUnit {
        id_unit
        description
        dian_code
        id_second
      }
      toUnit {
        id_unit
        description
        dian_code
        id_second
      }
    }
  }
`;

// Query to get conversions by unit
export const GET_UNIT_CONVERSIONS_BY_UNIT = gql`
  query GetUnitConversionsByUnit($idUnit: ID!) {
    getUnitConversionsByUnit(id_unit: $idUnit) {
      id_conversion
      from_unit
      to_unit
      conversion_factor
      is_bidirectional
      description
      is_active
      fromUnit {
        id_unit
        description
        dian_code
        id_second
      }
      toUnit {
        id_unit
        description
        dian_code
        id_second
      }
    }
  }
`;

// Query to get all available conversions from a unit
export const GET_AVAILABLE_CONVERSIONS_FROM_UNIT = gql`
  query GetAvailableConversionsFromUnit($idUnit: ID!, $company: String!) {
    getAvailableConversionsFromUnit(id_unit: $idUnit, company: $company) {
      unit {
        id_unit
        description
        dian_code
        id_second
      }
      conversion_factor
    }
  }
`;

// Query to get all conversions
export const GET_ALL_UNIT_CONVERSIONS = gql`
  query GetAllUnitConversions($page: Int, $size: Int) {
    getAllUnitConversions(page: $page, size: $size) {
      conversions {
        id_conversion
        from_unit
        to_unit
        conversion_factor
        is_bidirectional
        description
        is_active
        fromUnit {
          id_unit
          description
          dian_code
          id_second
        }
        toUnit {
          id_unit
          description
          dian_code
          id_second
        }
      }
      count
    }
  }
`;

// Mutation to create a unit conversion
export const CREATE_UNIT_CONVERSION = gql`
  mutation CreateUnitConversion(
    $fromUnit: ID!
    $toUnit: ID!
    $conversionFactor: Float!
    $isBidirectional: Boolean
    $description: String
  ) {
    createUnitConversion(
      from_unit: $fromUnit
      to_unit: $toUnit
      conversion_factor: $conversionFactor
      is_bidirectional: $isBidirectional
      description: $description
    ) {
      id_conversion
      from_unit
      to_unit
      conversion_factor
      is_bidirectional
      description
      is_active
    }
  }
`;
